import React from "react";
import { Box, Grid, Stack, Typography } from "convertupleads-theme";
import BasicRadioColor from "./BasicRadioColor";
import BasicRadioDisabled from "./BasicRadioDisabled";
import BasicRadioSize from "./BasicRadioSize";
import BasicRadioSizeLabel from "./BasicRadioSizeLabel";
import BasicRadioColorLabel from "./BasicRadioColorLabel";

const BasicRadio = () => {
  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Radio Group
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          RadioGroup is a helpful wrapper used to group Radio components that
          provides an easier API, and proper keyboard accessibility to the
          group.
        </Typography>
      </Box>

      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <Grid container rowSpacing={2} columnSpacing={2}>
          <Grid item xs={6}>
            <Typography variant="body1" fontSize={14}>
              Default size - small, medium, large
            </Typography>
            <BasicRadioSize />
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body1" fontSize={14}>
              Default disabled radio
            </Typography>
            <BasicRadioDisabled />
          </Grid>
        </Grid>

        <BasicRadioColor />

        <Grid container rowSpacing={2} columnSpacing={2}>
          <Grid item xs={12}>
            <Typography variant="body1" fontSize={14}>
              Default size with label
            </Typography>
            <BasicRadioSizeLabel />
          </Grid>
        </Grid>

        <BasicRadioColorLabel />
      </Box>
    </Stack>
  );
};

export default BasicRadio;
